/**
 * Where a reference check's work lives in the landlord portal, shared by every place that links
 * to it: the lead's Verifications tab (agent-off hint), the reference-check modal (agent off),
 * the escalation queue and the held-response queue (BR-ESC-QUEUE-REACH, DC-17).
 */

/** id of the Reference agent card on Settings → AI agents; the page scrolls to and focuses it. */
export const REFERENCE_AGENT_CARD_ID = 'reference-agent';

/** Settings → AI agents, straight to the Reference agent card (its on/off switch). */
export const REFERENCE_AGENT_SETTINGS_PATH = `/settings/agents#${REFERENCE_AGENT_CARD_ID}`;

/** Query param on the lead's Verifications tab naming the reference check to reveal (its case id). */
export const REFERENCE_CHECK_PARAM = 'referenceCheck';

/**
 * The lead's Verifications tab, opened on its reference check: the tab expands the applicant it
 * belongs to and scrolls to that applicant's Reference check section.
 */
export function referenceCheckLeadPath(leadId: string, referenceCheckId: string): string {
  return `/leasing/leads/${leadId}?tab=verifications&${REFERENCE_CHECK_PARAM}=${referenceCheckId}`;
}
